import React from 'react';
const stats = [['36', 'sesiones de 45 min'], ['108', 'fichas ilustradas'], ['12', 'semanas de programa'], ['4', 'bonos de regalo']];
export function SocialProofBar() {
  return <section className="w-full bg-[#0b3a2d] py-10 px-4 border-y border-[#F2C14E]/20" data-id="element-177" data-mp="29uficnm8znpb">
      <div className="max-w-5xl mx-auto grid grid-cols-2 sm:grid-cols-4 gap-6 text-center" data-id="element-178" data-mp="29s30sbkejfcs">
        {stats.map(([n, l]) => <div key={l} data-id="element-179" data-mp="32j4o4zy90h7e">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-180" data-mp="32jd10rudfmil">{n}</div>
            <div className="text-[#F2C14E] text-sm font-semibold mt-1" data-id="element-181" data-mp="2xk9uf2yqt88i">{l}</div>
          </div>)}
      </div>
    </section>;
}